import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import app from "../../firebaseConfig";
import { Menu } from "lucide-react";

const FarmerHeader = ({ onToggleSidebar }) => {
  const [fullName, setFullName] = useState("");

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;

        const firestore = getFirestore(app);
        const snap = await getDoc(doc(firestore, "users", user.uid));

        if (snap.exists()) {
          setFullName(snap.data().fullName || "");
        }
      } catch (error) {
        console.error("Error fetching farmer name:", error);
      }
    };

    fetchUserName();
  }, []);

  return (
    <header className="w-full bg-white shadow-md p-3 md:p-4 flex items-center justify-between gap-2">
      {/* Sidebar toggle */}
      <button
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar menu"
        className="text-green-700 hover:text-green-900 p-2 rounded-lg hover:bg-green-50 flex-shrink-0"
      >
        <Menu size={24} className="md:w-[26px] md:h-[26px]" />
      </button>

      {/* Welcome message */}
      <h1 className="text-base md:text-xl font-semibold text-green-700 truncate">
        Welcome, {fullName || "Farmer"} 👋
      </h1>

      {/* Right side placeholder (notifications/settings) */}
      <div className="w-8 flex-shrink-0" />
    </header>
  );
};

export default FarmerHeader;
